export enum StepTwoFormKeys {
  firstName = 'firstName',
  lastName = 'lastName',
  dateOfBirth = 'dateOfBirth',
  gender = 'gender',
  email = 'email',
  phoneNumber = 'phoneNumber',
  parentOrGuardian = 'parentOrGuardian',
  relationshipOfGuardian = 'relationshipOfGuardian',
  reasonForReferral = 'reasonForReferral',
  address1 = 'address1',
  address2 = 'address2',
  city = 'city',
  state = 'state',
  zip = 'zip',
}

export const STEP_TWO_DEFAULT_VALUES = {
  [StepTwoFormKeys.firstName]: '',
  [StepTwoFormKeys.lastName]: '',
  [StepTwoFormKeys.dateOfBirth]: '',
  [StepTwoFormKeys.gender]: '',
  [StepTwoFormKeys.email]: '',
  [StepTwoFormKeys.phoneNumber]: '',
  [StepTwoFormKeys.parentOrGuardian]: '',
  [StepTwoFormKeys.relationshipOfGuardian]: '',
  // [StepTwoFormKeys.reasonForReferral]: "asd \n\n\n Patient's Insurance: insurance",
  [StepTwoFormKeys.reasonForReferral]: '',
  [StepTwoFormKeys.address1]: '',
  [StepTwoFormKeys.address2]: '',
  [StepTwoFormKeys.city]: '',
  [StepTwoFormKeys.state]: '',
  [StepTwoFormKeys.zip]: '',
};

export const NAME_REGEX = /^[a-zA-Z'. -]+$/;
export const REASON_FOR_REFERRAL_REGEX = /^[a-zA-Z0-9\s'.-]+$/;
export const ADDRESS_REGEX = /^[a-zA-Z0-9\s'#.-]+$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,4}$/;
export const ZIP_REGEX = /^[0-9]{5}(-[0-9]{4})?$/;
export const MINIMUM_YEAR = 1900;
export const MAX_FIRST_NAME_CHARACTERS = 20;
export const MAX_LAST_NAME_CHARACTERS = 20;
export const MAX_REASON_FOR_REFERRAL_CHARACTERS = 250;
export const MAX_ADDRESS_ONE_CHARACTERS = 60;
export const MAX_ADDRESS_TWO_CHARACTERS = 20;
export const MAX_CITY_CHARACTERS = 25;
export const MAX_STATE_CHARACTERS = 5;
export const MAX_GUARDIANS_CHARACTERS = 60;

export const STATE_ZIP_CODE_RANGES: {
  [state: string]: [number, number][];
} = {
  AL: [[35004, 36925]],
  AK: [
    [99501, 99524],
    [99602, 99950],
  ],
  AZ: [[85001, 86556]],
  AR: [[71601, 72959]],
  CA: [
    [90001, 96162],
    [96200, 96699],
  ], // includes APO/FPO Pacific
  CO: [[80001, 81658]],
  CT: [[6001, 6928]],
  DE: [[19701, 19980]],
  FL: [[32003, 34997]],
  GA: [
    [30002, 31999],
    [39813, 39901],
  ],
  HI: [[96701, 96898]],
  ID: [[83201, 83877]],
  IL: [[60001, 62999]],
  IN: [[46001, 47997]],
  IA: [[50001, 52809]],
  KS: [[66002, 67954]],
  KY: [[40003, 42788]],
  LA: [[70001, 71497]],
  ME: [[3901, 4992]],
  MD: [
    [20588, 20588],
    [20601, 21930],
  ],
  MA: [
    [1001, 2791],
    [5501, 5544],
  ],
  MI: [[48001, 49971]],
  MN: [[55001, 56763]],
  MS: [[38601, 39776]],
  MO: [[63001, 65899]],
  MT: [[59001, 59937]],
  NE: [[68001, 69367]],
  NV: [[88901, 89883]],
  NH: [[3031, 3897]],
  NJ: [[7001, 8989]],
  NM: [[87001, 88439]],
  NY: [
    [501, 501],
    [6390, 6390],
    [10001, 14925],
  ],
  NC: [[27006, 28909]],
  ND: [[58001, 58856]],
  OH: [[43001, 45999]],
  OK: [[73001, 74966]],
  OR: [[97001, 97920]],
  PA: [[15001, 19640]],
  RI: [[2801, 2940]],
  SC: [[29001, 29945]],
  SD: [[57001, 57799]],
  TN: [[37010, 38589]],
  TX: [
    [73301, 73301],
    [75001, 75501],
    [75503, 79999],
    [88510, 88595],
  ],
  UT: [[84001, 84791]],
  VT: [[5001, 5907]],
  VA: [
    [20101, 20199],
    [22001, 24658],
  ],
  WA: [[98001, 99403]],
  WV: [[24701, 26886]],
  WI: [[53001, 54990]],
  WY: [[82001, 83414]],
  DC: [
    [20001, 20099],
    [20201, 20599],
    [56901, 56999],
  ],
  PR: [
    [601, 799],
    [901, 988],
  ],
  VI: [[801, 851]],
  GU: [[96910, 96932]],
  AS: [[96799, 96799]],
  MP: [[96950, 96952]],
};
